import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { useEffect } from "react";
import { Toaster } from "@/components/ui/sonner";
import Layout from "@/components/Layout";
import Home from "@/pages/Home";
import About from "@/pages/About";
import Programs from "@/pages/Programs";
import Workshops from "@/pages/Workshops";
import Calendar from "@/pages/Calendar";
import WorkshopRegistration from "@/pages/WorkshopRegistration";
import Scholarship from "@/pages/Scholarship";
import Donate from "@/pages/Donate";
import DonateSuccess from "@/pages/DonateSuccess";
import Contact from "@/pages/Contact";
import MentorshipForm from "@/pages/MentorshipForm";
import VolunteerForm from "@/pages/VolunteerForm";
import ReferralForm from "@/pages/ReferralForm";
import Partners from "@/pages/Partners";
import LiftHerUp from "@/pages/LiftHerUp";
import AdminCalendar from "@/pages/AdminCalendar";

// ScrollToTop component to reset scroll position on route change
function ScrollToTop() {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    // If there's a hash (anchor link), let the browser handle it
    // Otherwise scroll to top
    if (!hash) {
      window.scrollTo(0, 0);
    }
  }, [pathname, hash]);

  return null;
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ScrollToTop />
        <Routes>
          <Route path="/" element={<Layout />}>
            <Route index element={<Home />} />
            <Route path="about" element={<About />} />
            <Route path="programs" element={<Programs />} />
            <Route path="workshops" element={<Workshops />} />
            <Route path="calendar" element={<Calendar />} />
            <Route path="register" element={<WorkshopRegistration />} />
            <Route path="scholarship" element={<Scholarship />} />
            <Route path="donate" element={<Donate />} />
            <Route path="donate/success" element={<DonateSuccess />} />
            <Route path="contact" element={<Contact />} />
            <Route path="mentorship-form" element={<MentorshipForm />} />
            <Route path="volunteer-form" element={<VolunteerForm />} />
            <Route path="referral-form" element={<ReferralForm />} />
            <Route path="partners" element={<Partners />} />
            <Route path="lift-her-up" element={<LiftHerUp />} />
            <Route path="admin/calendar" element={<AdminCalendar />} />
          </Route>
        </Routes>
      </BrowserRouter>
      <Toaster position="top-right" richColors />
    </div>
  );
}

export default App;
